<template>
  <div class="card-content">
    <div class="mt-s">
      <div class="mb-5 w-full">
        <fieldset>
          <div class="form-group">
            <input
              v-model="searchQuery"
              type="search"
              class="form-control form-search"
              placeholder="Type to find what you are looking for"
              aria-controls="datatables"
              autofocus
            />
          </div>
        </fieldset>
      </div>

      <div>
        <el-table
          class="table-striped table-with-tooltip"
          :data="queriedData"
          :default-sort="defaultSort"
          border
          style="width: 100%"
        >
          <el-table-column prop="topicName" label="Name" min-width="450">
            <template #default="props">
              <div class="flex">
                <Icon v-if="!(props.row.periodicity === 'Initial only' && props.row.completed_at !== null)" :type="props.row.topicStatus" class="mr-2" />

                <div class="mr-3">
                  {{ props.row.topicName }}
                </div>

                <Icon
                  v-for="condition in props.row.conditions"
                  :key="condition"
                  class="mr-2"
                  :type="condition"
                />
              </div>
            </template>
          </el-table-column>

          <el-table-column width="54">
            <template #default="props">
              <i
                class="text-info fa-2x fad fa-file-certificate"
                @click="downloadCertificate(props.row.certificate)"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- <div class="flex justify-between items-center">
        <div>
          <p class="category">
            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
          </p>
        </div>

        <p-pagination
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
        />

        <div>
          <el-select
            v-model="pagination.perPage"
            class="select-default"
            placeholder="Per page"
          >
            <el-option
              v-for="item in pagination.perPageOptions"
              :key="item"
              class="select-default"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import Icon from "@components/UIComponents/TopicIcon/Icon";
import tableConfig from "@providers/table";
import Vue from "vue";
import { Table, TableColumn } from "element-ui";
import mapper from "@components/UIComponents/TopicIcon/mapper.json";
import HelperDate from "@helpers/dates";
//import PPagination from "@components/UIComponents/Pagination.vue";

Vue.use(Table);
Vue.use(TableColumn);

export default {
  components: {
    Icon,
    //PPagination,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  emits: ["printCertificate", "downloadCertificate"],
  data() {
    return {
      expends: [],
      tableStatus: false,
      ...tableConfig.data,
      propsToSearch: ["topicName"],
      defaultSort: { prop: "topicName", order: "ascending" },
    };
  },
  computed: {
    tableData() {
      return !this.data.topics ? [] : this.parseData(this.data.topics);
    },
    ...tableConfig.computed,
  },
  methods: {
    parseData(data) {
      return data.map((topic) => {
        return {
          id: topic.id,
          certificate: topic.certificate,
          conditions: this.getIconConditions(topic),
          topicStatus: this.getStatus(topic.status),
          topicName: topic.topicName,
          periodicity: topic.periodicity,
          completed_at: this.formatDate(topic.completed_at),
          expiry: this.formatDate(topic.expiry),
          lessons: topic.lessons,
        };
      });
    },
    getIconConditions(topic) {
      const conditions = ["seasonal", "compressed", "expiration"];
      return conditions.filter((cond) => topic[cond]);
    },
    getStatus(status) {
      if (!status) {
        return;
      }

      const stringfiedStatus = String(status);

      const [iconName] = Object.entries(mapper).find(([, value]) => {
        return value.code === stringfiedStatus;
      });

      const rejectStatus = ["completed"];

      if (rejectStatus.includes(iconName)) {
        return;
      }

      return iconName;
    },
    formatDate(date) {
      return HelperDate.formatDate(date);
    },
    formatDateTime(date) {
      return HelperDate.formatDateTime(date);
    },
    printCertificate(row) {
      this.$emit("printCertificate", row);
    },
    downloadCertificate(row) {
      this.$emit("downloadCertificate", row);
    },
  },
};
</script>
